import React, { useState } from 'react';
import Project1Image from '../assets/project/1.jpeg';
import Project2Image from '../assets/project/2f.jpeg';
import Planttt from '../assets/gallery/newaddpicbessandsolarpic/planttt.jpg';
import Plantttt from '../assets/gallery/newaddpicbessandsolarpic/plantttt.jpg';
import Planttttt from '../assets/gallery/newaddpicbessandsolarpic/planttttt.jpg';
import PlanLatest from '../assets/gallery/newaddpicbessandsolarpic/planlatest.jpg';
import SolarReady from '../assets/gallery/newaddpicbessandsolarpic/soalarready.jpg';
import '../styles/Projects.scss';

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('solar');

  const projects = [
    {
      id: 1,
      year: 2017,
      month: "DEC",
      title: "Solar Operations Expansion",
      description: "Established our solar division with EPC contracts for mega-watt scale projects and secured prestigious government contracts.",
      achievements: [
        "1000+ MW EPC Contract",
        "02+ MW EPC Projects from MES Air Force Station Barmer, Rajasthan"
      ],
      stats: {
        capacity: "500+ MW",
        focus: "EPC Services"
      },
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
      category: "solar",
      location: "Barmer, Rajasthan"
    },
    {
      id: 2,
      year: 2019,
      month: "DEC",
      title: "Solar Supply Chain Growth",
      description: "Expanded our supply chain with commercial-scale solar modules and industrial-grade inverters across multiple states.",
      achievements: [
        "10+ MW Solar Module Supply",
        "5+ MW Solar Grid Tie Inverter Supply",
        "01+ MW EPC Projects from MES Air Force Station Phalodi, Rajasthan"
      ],
      stats: {
        capacity: "+10 MW Modules, +5 MW Inverters",
        regions: "5+ States"
      },
      image: require('../assets/project/solor-suppy-chain-growth.png'),
      category: "solar",
      location: "Multiple States"
    },
    {
      id: 3,
      year: 2021,
      month: "DEC",
      title: "Industrial Solar Expansion",
      description: "Significant growth in industrial solar installations across Rajasthan with pan-India module and inverter distribution.",
      achievements: [
        "10+ MW Solar I&C Work in Rajasthan",
        "10+ MW Solar Module Supply",
        "05+ MW Solar Inverter Supply",
        "EPC Projects from Military Engineering Services Air Force Station Barmer"
      ],
      stats: {
        capacity: "5+ MW I&C, +10 MW Modules, +5 MW Inverters",
        reach: "Pan India"
      },
      image: Planttt,
      category: "solar",
      location: "Pan India"
    },
    {
      id: 4,
      year: 2022,
      month: "DEC",
      title: "Solar Installation Milestone",
      description: "Major expansion in large-scale solar installations with significant projects in KUSUM and C&I segments.",
      achievements: [
        "50+ MW Solar I&C Work in Rajasthan",
        "50+ MW Solar Power Plants in KUSUM and C&I Segments",
        " Work at Military Station Kachrapar A and Kakinara",
        "100+ Houses Solarized Under Roof-top Subsidy Schemes"
      ],
      stats: {
        capacity: "50+ MW",
      },
      image: require('../assets/project/ghasw.png'),
      category: "solar",
      location: "Rajasthan & West Bengal"
    },
    {
      id: 5,
      year: 2023,
      month: "DEC",
      title: "Solar Industry Leadership",
      description: "Achieved significant market expansion with massive module supply and landmark solar project commissions.",
      achievements: [
        "100+ MW Modules Supplied in Pan India",
        "100+ MW Solar Project Commissioned Under KUSUM A Component",
        "100+ MW LOA Under KUSUM C Component in Rajasthan",
        "50+ Employees Added to Our Team",
        "Benchmark of Adani Solar in Western Rajasthan"
      ],
      stats: {
        capacity: "100+ MW Modules, +70 MW Projects",
        manpower: "100+ Employees"
      },
      image: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
      category: "solar",
      location: "Western Rajasthan"
    },
    {
      id: 6,
      year: 2024,
      month: "DEC",
      title: "Record-Breaking Solar Performance",
      description: "Exceptional growth in module supply and solar project installations with record-breaking achievements.",
      achievements: [
        "200+ MW Modules Supplied in Pan India",
        "100= MW Solar Projects Commissioned Under KUSUM A Component",
        "200+ MW Solar Projects Commissioned Under KUSUM C Component",
        "100+ Team Members"
      ],
      stats: {
        capacity: "200+ MW Modules, 500+ MW Projects",
        financial: "Contact"
      },
      image: Planttttt,
      category: "solar",
      location: "Pan India"
    },
    {
      id: 7,
      year: 2025,
      month: "AUG",
      title: "Solar Vision 2025",
      description: "Setting new industry standards with unprecedented scale module supply and landmark solar project commissions.",
      achievements: [
        "200+ MW Modules Supplied in Pan India",
        "500+ MW Solar Projects Commissioned Under KUSUM C Component",
        "50+ New Team Members",
        "Benchmark of Adani Solar in All Rajasthan"
      ],
      stats: {
        capacity: "200+ MW Modules, 500+ MW Projects",
      },
      image: PlanLatest,
      category: "solar",
      location: "All Rajasthan"
    },
    {
      id: 8,
      title: "Projects Oct-2025",
      description: "We're expanding our renewable energy portfolio with innovative solar solutions and cutting-edge BESS technology. Stay tuned for our next wave of sustainable energy initiatives.",
      upcoming: true,
      stats: {
        focus: "Innovation"
      },
      image: SolarReady,
      category: "solar",
      location: "Pan India"
    },
    {
      id: 9,
      title: "Battery Energy Storage System (BESS)",
      description: "Advanced BESS containers providing modular energy storage solutions for grid stabilization, renewable integration, and backup power applications.",
      category: "bess",
      features: [
        {
          title: "BESS Technology",
          content: "Standardized, pre-fabricated enclosures housing large-scale energy storage systems designed for seamless integration with renewable energy sources."
        },
        {
          title: "Core Components",
          content: "Battery modules, Power Conversion System, Energy Management System, Battery Management System, Thermal management, and Safety systems."
        },
        {
          title: "Applications",
          content: "Renewable energy integration, Grid stabilization, Backup power, Commercial & industrial energy management."
        },
        {
          title: "Benefits",
          content: "Reduced energy costs, improved reliability, balanced energy supply and demand, emergency backup power, grid stability."
        }
      ]
    }
  ];

  const categories = ['solar', 'bess'];

  const filteredProjects = projects.filter(project => project.category === activeFilter);

  // Handle PDF download
  const handleDownloadProfile = () => {
    const link = document.createElement('a');
    link.href = '/RRI Profile.pdf';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.download = 'RRI Profile.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="projects-section section-padding" id="projects">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">Our Projects</h2>
          <p className="section-subtitle">
            Showcasing our journey of excellence in solar energy solutions and BESS installations
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="filter-tabs">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-tab ${activeFilter === category ? 'active' : ''}`}
              onClick={() => setActiveFilter(category)}
            >
              {category === 'solar' ? 'Solar Projects' : 'BESS Solutions'}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="projects-grid">
          {filteredProjects.map((project) => (
            project.category === 'solar' ? (
              <div key={project.id} className={`project-card ${project.upcoming ? 'upcoming' : ''}`}>
                <div className="project-image">
                  <img
                    src={project.image}
                    alt={`${project.title} - Solar project in ${project.location}`}
                    loading="lazy"
                  />
                  <div className="project-badge">
                    {project.upcoming ? '🔮' : '☀️'}
                  </div>
                </div>

                <div className="project-content">
                  {project.month && project.year && (
                    <div className="project-date">
                      {project.month} {project.year}
                    </div>
                  )}

                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-description">{project.description}</p>

                  <div className="project-stats">
                    {Object.entries(project.stats).slice(0, 2).map(([key, value]) => (
                      <span key={key} className="stat-badge">
                        <strong>{key}:</strong> {value}
                      </span>
                    ))}
                  </div>

                  <div className="project-location">
                    📍 {project.location}
                  </div>
                </div>
              </div>
            ) : (
              <div key={project.id} className="bess-container">
                <div className="bess-header">
                  <div className="bess-icon">🔋</div>
                  <h3 className="bess-title">{project.title}</h3>
                  <p className="bess-description">{project.description}</p>
                </div>

                <div className="bess-features">
                  {project.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="bess-feature">
                      <h4 className="feature-title">{feature.title}</h4>
                      <p className="feature-content">{feature.content}</p>
                    </div>
                  ))}
                </div>
              </div>
            )
          ))}
        </div>

        {/* Download Profile Section */}
        {/* <div className="download-section">
          <div className="download-card" onClick={handleDownloadProfile}>
            <div className="download-icon">📄</div>
            <h4 className="download-title">Complete Portfolio & Company Profile</h4>
            <p className="download-description">
              Click here to view our complete portfolio and download the detailed company profile & Projects.
            </p>
            <button className="download-btn">Download Profile</button>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Projects;